exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app {\n  font-family: \"\\5FAE\\8F6F\\96C5\\9ED1\", Helvetica, Arial, sans-serif;\n  text-align: center;\n  color: #333;\n  min-height: 100%;\n  height: 100%;\n  /* background-color: #f9f9f9 */\n}\n", "", {"version":3,"sources":["/Users/sogouo/Company/bk/front/euc-staff/src/src/App.vue"],"names":[],"mappings":";AAkBA;EACA,kEAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,+BAAA;CACA","file":"App.vue","sourcesContent":["<!--\n * @Descripttion:\n * @Author: 李子和\n * @Date: 2019-12-03 14:30:16\n -->\n<template>\n  <div id=\"app\">\n    <router-view />\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'App'\n}\n</script>\n\n<style>\n#app {\n  font-family: \"微软雅黑\", Helvetica, Arial, sans-serif;\n  text-align: center;\n  color: #333;\n  min-height: 100%;\n  height: 100%;\n  /* background-color: #f9f9f9 */\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = z/+d
// module chunks = 21